export default function omitKeys(obj, keys) {
    const objCopy = {
        ...obj,
    };
    keys.forEach(key => {
        delete objCopy[key];
    });
    return objCopy;
}
